import isBrowser from '../../../utils/isBrowser';
export default function isDocumentVisible() {
  if (isBrowser) {
    return document.visibilityState !== 'hidden';
  }

  return true;
}